/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The UpdateCustomerSupplyAppointmentsResponse model module.
* @module model/UpdateCustomerSupplyAppointmentsResponse
* @version 2020-12-7
*/
export default class UpdateCustomerSupplyAppointmentsResponse {
    /**
    * Constructs a new <code>UpdateCustomerSupplyAppointmentsResponse</code>.
    * 供給予約更新レスポンス
    * @alias module:model/UpdateCustomerSupplyAppointmentsResponse
    * @class
    * @param result {module:model/UpdateCustomerSupplyAppointmentsResponse.ResultEnum} 
    */

    constructor(result) {
        
        
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>UpdateCustomerSupplyAppointmentsResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/UpdateCustomerSupplyAppointmentsResponse} obj Optional instance to populate.
    * @return {module:model/UpdateCustomerSupplyAppointmentsResponse} The populated <code>UpdateCustomerSupplyAppointmentsResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdateCustomerSupplyAppointmentsResponse();
                        
            
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {module:model/UpdateCustomerSupplyAppointmentsResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
